<template>
    <section class="nti-checkout-line__bottom-buttons">
        <a @click.prevent="continueShopping"
                class="nti-button nti-button--return nti-button__link"
                :aria-label="continueShoppingLabel">
            <div class="nti-svg__container-small nti-svg--arrow-left">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path
                        d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                    />
                </svg>
            </div>
            <p>{{ continueShoppingLabel }}</p>
        </a>

        <a :href="checkOutPageUrl" class="nti-button nti-button--confirm nti-button__link pardotTrackClick" :aria-label="checkOutButtonText">
            <p>{{ checkOutButtonText }}</p>
            <div class="nti-svg__container-small nti-svg--go-to-checkout">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                </svg>
            </div>
        </a>
    </section>
</template>

<script>
import store from 'store'
import verifyLabel from '../../../methods/verifyLabel'
import cookieControl from '../../../methods/cookieControl'

export default {
    props: {
        labels: Object,
        dataShoppingUrl: String,
        continueShoppingLabel: String,
        checkOutPageUrl: String,
        checkOutButtonText: String
    },
    computed: {
        checkoutLabels() {
            if (store.state.main.labels) {
                return store.state.main.labels
            }
        },
        continueShoppingUrl() {
            return this.dataShoppingUrl;
        }
    },
    methods: {
        verifyLabel(displayName) {
            if (store.state.main.labels) {
                return verifyLabel(displayName, store.state.main.labels)
            } else {
                return ""
            }
        },
        continueShopping() {
            let cookie = cookieControl.getItem("shopfilter")
            if (!cookie || cookie === 'undefined') {
                cookieControl.removeItem('shopfilter', '/')
                cookie = null
            }
            const url = this.continueShoppingUrl

            window.location.href = cookie && url
                ? `${url}${cookie}`
                : url
                    ? url
                    : '/'
        }
    }
}
</script>
